<template>
  <div class="video-wrapper">
    <fn-iframe-wrapper>
      <fn-youtube-embed-lite
        :thumb-quality="thumbQuality"
        :video="video"
        :params="{ autoplay: 1, enablejsapi: 1, origin: originUrl }"
      />
    </fn-iframe-wrapper>
  </div>
</template>
<script>
export default {
  props: {
    video: {
      type: String,
      required: true,
    },
    thumbQuality: {
      type: String,
      default: 'hq',
    },
  },
  computed: {
    originUrl() {
      return this.$host;
    },
  },
};
</script>

<style lang="scss" scoped>
.video-wrapper .iframe-wrapper {
  border-radius: map-get($border-radiuses, 'xxl');
  z-index: 10;
}
</style>
